export const convert2slug = name => {
  return name?.replace(/\s/g, '-');
};
